import { Typography, Box } from '@mui/material'
import { LeafIcon } from '@thriveglobal/thrive-web-leafkit'
import { IconName } from '@fortawesome/fontawesome-common-types'

const variants = {
    primary: { color: 'text.primary' },
    success: { color: 'accent.main' },
    disabled: { color: 'text.disabled' }
}

export default function CardStatus({
    label,
    iconName,
    IconComponent,
    variant = 'primary',
    sx
}: {
    label?: string
    iconName?: IconName
    IconComponent?: React.ReactNode
    variant?: keyof typeof variants
    sx?: Record<string, any>
}) {
    return (
        <Typography
            variant="body2"
            component="span"
            sx={{
                display: 'flex',
                alignItems: 'center'
            }}
            color={variants[variant].color}
        >
            <Box
                component="span"
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    ...sx
                }}
            >
                {(iconName || IconComponent) && (
                    <Box sx={{ mr: 0.5, display: 'flex' }}>
                        {IconComponent && IconComponent}
                        {iconName && !IconComponent && (
                            <LeafIcon
                                icon={iconName}
                                fontSize={'small'}
                                data-testid={`card-icon-${iconName}`}
                            />
                        )}
                    </Box>
                )}
                {label}
            </Box>
        </Typography>
    )
}
